/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/online-store/asset
 * API Version: 2022-01
 */

import { UniqueValidationId } from "../../database/validations/keys";
import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyAssetKey,
  ShopifyAssetKeyUniquenessValidationKey,
  ShopifyAssetToShopKey,
  ShopifyAssetToThemeKey,
  ShopifyShopKey,
  ShopifyThemeKey,
} from "./keys";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion, ShopifyApiVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyAssetKey,
  "2022-01": {
    name: "Shopify Asset",
    fields: [
      {
        name: "Attachment",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "attachment" } },
      },
      {
        name: "Checksum",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "checksum" } },
      },
      {
        name: "Content Type",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "content_type" } },
      },
      {
        name: "Key",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "key" } },
        validations: {
          [ShopifyAssetKeyUniquenessValidationKey]: {
            key: ShopifyAssetKeyUniquenessValidationKey,
            specID: UniqueValidationId,
            configuration: {
              values: {
                scopeByField: ShopifyAssetToThemeKey,
              },
            },
          },
        },
      },
      {
        name: "Public URL",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "public_url" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "Size",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "size" } },
      },
      {
        name: "Theme",
        fieldType: FieldType.BelongsTo,
        key: ShopifyAssetToThemeKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "theme_id" } },
        configuration: {
          relatedModelKey: ShopifyThemeKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyAssetToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_sublist", resource: "asset", parent: "theme" },
  },
};

export const ShopifyAsset = ({ apiVersion }: { apiVersion: ShopifyApiVersion }) => buildConnectionSpec(specs, apiVersion);
